import { caution } from '../images';
import { fieldGeneratorMapping } from '../shared';
import { oppositesToDropdown } from '../../utils';
import config from '../../../../common/const';
import { translate } from '../../../../../common/i18n';

export const marketDropdown = block => {
    block
        .appendDummyInput('MARKETDEFINITION')
        .appendField(`${translate('Market')}:`)
        .appendField(new Blockly.FieldDropdown(fieldGeneratorMapping.MARKET_LIST()), 'MARKET_LIST')
        .appendField('❯')
        .appendField(new Blockly.FieldDropdown(fieldGeneratorMapping.SUBMARKET_LIST(block)), 'SUBMARKET_LIST')
        .appendField('❯')
        .appendField(new Blockly.FieldDropdown(fieldGeneratorMapping.SYMBOL_LIST(block)), 'SYMBOL_LIST');
};

export const tradeTypeDropdown = block => {
    const getContractTypes = () => {
        const tradeType = block.getFieldValue('TRADETYPE_LIST');
        if (tradeType && tradeType !== 'na') {
            return [[translate('Both'), 'both'], ...oppositesToDropdown(config.opposites[tradeType.toUpperCase()])];
        }
        return [[translate('Not available'), 'na']];
    };
    block
        .appendDummyInput('TRADETYPEDEFINITION')
        .appendField(`${translate('Trade Type')}:`)
        .appendField(new Blockly.FieldDropdown(fieldGeneratorMapping.TRADETYPECAT_LIST(block)), 'TRADETYPECAT_LIST')
        .appendField('❯')
        .appendField(new Blockly.FieldDropdown(fieldGeneratorMapping.TRADETYPE_LIST(block)), 'TRADETYPE_LIST')
        .appendField(translate('Contract Type:'))
        .appendField(new Blockly.FieldDropdown(getContractTypes), 'TYPE_LIST');
};

export const contractTypes = block => {
    if (!block.getInput('CONTRACT_TYPE')) {
        const getContractTypes = () => {
            const tradeType = block.getFieldValue('TRADETYPE_LIST');
            if (tradeType && tradeType !== 'na') {
                return [[translate('Both'), 'both'], ...oppositesToDropdown(config.opposites[tradeType.toUpperCase()])];
            }
            return [[translate('Not available'), 'na']];
        };
        block
            .appendDummyInput('CONTRACT_TYPE')
            .appendField(translate('Contract Type:'))
            .appendField(new Blockly.FieldDropdown(getContractTypes), 'TYPE_LIST');
    }
};

export const candleInterval = block => {
    if (!block.getInput('CANDLE_INTERVAL')) {
        block
            .appendDummyInput('CANDLE_INTERVAL')
            .appendField(translate('Default Candle Interval:'))
            .appendField(new Blockly.FieldDropdown(config.candleIntervals.slice(1)), 'CANDLEINTERVAL_LIST');
    }
};

export const duration = block => {
    if (!block.getInput('DURATION')) {
        block
            .appendValueInput('DURATION')
            .setCheck('Number')
            .appendField(translate('Duration:'))
            .appendField(new Blockly.FieldDropdown([['', '']]), 'DURATIONTYPE_LIST');
    }
};

export const multipliers = block => {
    const inputName = 'MULTIPLIER';
    if (!block.getInput(inputName)) {
        block
            .appendValueInput(inputName)
            .setCheck('Number')
            .appendField(`${translate('Multiplier')}:`);

        block
            .appendValueInput('TAKEPROFIT')
            .setCheck('Number')
            .appendField(`${translate('Take Profit')}:`);
        
        block
            .appendValueInput('STOPLOSS')
            .setCheck('Number')
            .appendField(`${translate('Stop Loss')}:`);

        let input = block.getInput(inputName);
        input.setVisible(false);
        input = block.getInput('TAKEPROFIT');
        input.setVisible(false);
        input = block.getInput('STOPLOSS');
        input.setVisible(false);
    }
};

export const payout = block => {
    if (!block.getInput('AMOUNT')) {
        const amountInput = block.appendValueInput('AMOUNT');

        amountInput.setCheck('Number');

        if (block.type === 'tradeOptions_payout') {
            amountInput.appendField(`${translate('Payout')}:`);
        } else {
            amountInput.appendField(`${translate('Stake')}:`);
        }

        amountInput.appendField(new Blockly.FieldDropdown(config.lists.CURRENCY), 'CURRENCY_LIST');

        // block
        //     .appendValueInput('AMOUNT')
        //     .setCheck('Number')
        //     .appendField(block.type === 'tradeOptions_payout' ? `${translate('Payout')}:` : `${translate('Stake')}:`)
        //     .appendField(new Blockly.FieldDropdown(config.lists.CURRENCY), 'CURRENCY_LIST');
    }
};

export const barrierOffsetGenerator = (inputName, block, name = 'Barrier') => {
    if (!block.getInput(inputName)) {
        // Determine amount of barrierOffset-blocks on workspace
        const barrierNumber = block.inputList.filter(input => /BARRIEROFFSET$/.test(input.name)).length;

        // Set barrier options according to barrierNumber (i.e. Offset + and Offset -)
        const barrierOffsetList = new Blockly.FieldDropdown(config.barrierTypes);
        barrierOffsetList.prefixField = null;
        barrierOffsetList.menuGenerator_ = config.barrierTypes; // eslint-disable-line no-underscore-dangle
        barrierOffsetList.setValue('');
        barrierOffsetList.setValue(config.barrierTypes[barrierNumber % config.barrierTypes.length][1]);

        block
            .appendValueInput(inputName)
            .setCheck('Number')
            .appendField(`${translate(name)}:`)
            .appendField(barrierOffsetList, `${inputName}TYPE_LIST`);

        const input = block.getInput(inputName);
        input.setVisible(false);
    }
};

export const prediction = block => {
    const inputName = 'PREDICTION';
    if (!block.getInput(inputName)) {
        block
            .appendValueInput(inputName)
            .setCheck('Number')
            .appendField(`${translate('Prediction')}:`);

        const input = block.getInput(inputName);
        input.setVisible(false);
    }
};

export const growthRate = block => {
    const inputName = 'GROWTHRATE';
    if (!block.getInput(inputName)) {
        block
            .appendValueInput(inputName)
            .setCheck('Number')
            .appendField(`${translate('Growth Rate')}:`);

        const input = block.getInput(inputName);
        input.setVisible(false);
    }
};

export const restart = block => {
    block
        .appendDummyInput()
        .appendField(`${translate('Restart buy/sell on error')}`)
        // .appendField(`(${translate('disable for better performance')}):`)
        .appendField(new Blockly.FieldCheckbox('true'), 'TIME_MACHINE_ENABLED')
        .appendField(`${translate('Restart last trade on error')}`)
        // .appendField(`(${translate('bot ignores the unsuccessful trade')}):`)
        .appendField(new Blockly.FieldCheckbox('TRUE'), 'RESTARTONERROR');
    block
        .appendDummyInput()
        .appendField(`${translate('Use 5000 candles/ticks (heavy processing)')}`)
        // .appendField(`(${translate('bot ignores the unsuccessful trade')}):`)
        .appendField(new Blockly.FieldCheckbox('FALSE'), 'USE5000');
    // .appendField(new Blockly.FieldImage(caution, 15, 15, '!'));
};

export const virtualTrades = block => {
    block.appendDummyInput()
        .appendField(`${translate('Virtual Trades Settings')}:`)
        .appendField(new Blockly.FieldDropdown([[translate('Disabled'), 'disabled'], [translate('Enabled'), 'enabled']]), 'VIRTUAL_ACTIVE')
        .appendField(`${translate('Max Steps')}:`)
        .appendField(new Blockly.FieldNumber(1, 1, 50), 'VIRTUAL_STEPS')
        .appendField(`${translate('Reset on win')}:`)
        .appendField(new Blockly.FieldDropdown([[translate('Disabled'), 'disabled'], [translate('Enabled'), 'enabled']]), 'VIRTUAL_RESET')
        .appendField(`${translate('Token')}:`)
        .appendField(new Blockly.FieldTextInput(translate('demo account token here')), 'VIRTUAL_TOKEN');

    block.appendDummyInput()
        .appendField(`                   ${translate('Min. Trades on Real')}:`)
        .appendField(new Blockly.FieldNumber(1, 1, 50), 'VIRTUAL_MINSTEPS')
        .appendField(`${translate('Max. Trades on Real')}:`)
        .appendField(new Blockly.FieldNumber(1, 1, 50), 'VIRTUAL_MAXSTEPS')
        .appendField(`${translate('Go Back to Virtual')}:`)
        .appendField(new Blockly.FieldDropdown([[translate('Win'), 'win'], [translate('Loss'), 'loss'], [translate('Any'), 'any']]), 'VIRTUAL_GOBACK')
}



// WEBPACK FOOTER //
// ./src/botPage/view/blockly/blocks/trade/components.js